import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExpandableComponent } from '../../model/uiControl'

export interface UiControlState {
  expandedComponentId: ExpandableComponent | null
}

export const uiControlInitialState: UiControlState = {
  expandedComponentId: ExpandableComponent.SHIPPING_OPTION,
}

const uiControlSlice = createSlice({
  name: 'uiControl',
  initialState: uiControlInitialState,
  reducers: {
    setExpandedComponent(state: UiControlState, action: PayloadAction<ExpandableComponent | null>) {
      state.expandedComponentId = action.payload
    },
  },
})

export const { setExpandedComponent } = uiControlSlice.actions

export default uiControlSlice.reducer
